import { makeObservable, observable, action } from 'mobx';
import { HttpResponse } from '../classes/httpResponse/index.js';
import '../../../tslib.es6-14c74580.js';
import '../enums/GameSpecificTypes.js';
import '../enums/MaxPayoutDataTypes.js';
import '../enums/Chat.js';
import '../enums/GameModes.js';
import '../enums/IconTypes.js';
import '../enums/BetStatus.js';
import '../enums/PopupTypes.js';
import '../enums/ApiVersion.js';
import '../enums/RoundStatus.js';
import '../enums/RequestStatus.js';
import '../enums/FreeBetsStatus.js';
import '../enums/SocketEvents.js';
import '../enums/TranslationKeys.js';
import '../enums/TimeoutMaxValue.js';
import '../enums/ApiServiceTypes.js';
import '../enums/EnvironmentTypes.js';
import '../enums/FreeBetWinningType.js';
import '../enums/DefaultQueryParams.js';
import '../enums/BetHistoryFilterTypes.js';
import '../enums/GameThemeTypes.js';
import '../enums/FetchDefaultPaths.js';
import '../enums/ResponseCodes.js';

var ResultHashStore = /** @class */ (function () {
    function ResultHashStore() {
        this.result = new HttpResponse(null);
        makeObservable(this, {
            result: observable,
            setResult: action.bound,
        });
    }
    ResultHashStore.prototype.setResult = function (result) {
        this.result = result;
    };
    ResultHashStore.prototype.fetchingResult = function () {
        this.setResult(this.result.fetching());
    };
    ResultHashStore.prototype.fetchedResult = function (hash) {
        this.setResult(this.result.fetched(hash));
    };
    ResultHashStore.prototype.resetResult = function () {
        this.setResult(this.result.fetching(true));
    };
    return ResultHashStore;
}());
var resultHashStore = new ResultHashStore();

export { ResultHashStore, resultHashStore };
